import React from 'react';
import './TokenExpiredPrompt.css';

const TokenExpiredPrompt = ({ onRefresh, userRole, loading }) => {
  return (
    <div className="token-expired-container">
      <div className="token-expired-content">
        <div className="token-expired-icon">
          <svg 
            width="64" 
            height="64" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" 
              fill="#f59e0b"
            />
          </svg>
        </div>
        
        <h2 className="token-expired-title">Session Expired</h2>
        
        <p className="token-expired-message">
          Your session has expired for security reasons. Please refresh to continue accessing your account.
        </p>
        
        <button 
          onClick={onRefresh}
          disabled={loading}
          className={`refresh-button ${loading ? 'loading' : ''}`}
        >
          {loading ? (
            <>
              <div className="spinner"></div>
              Refreshing...
            </>
          ) : (
            'Refresh'
          )}
        </button>
      </div>
    </div>
  );
};

export default TokenExpiredPrompt;